module.exports = __webpack_public_path__ + "media/images/top/works04-7f9e5f546c96d95fcf28f9a1110939c3.jpg";